// @flow strict
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
// See https://jira.tamg.io/browse/WP-2462
import * as React from 'react';
import classnames from '@ta/common.classnames';
import styles from './ModalBody.css';

type Props = {|
  /** Takes up the entire width and height of the modal
   * (i.e., no padding) */
  isFullBleed?: boolean,
  /** The body scroll type */
  bodyScroll?: 'hidden' | 'visible',
  /** Callback fired when when user drags over the body */
  onDragOver?: (e: SyntheticDragEvent<HTMLDivElement>) => mixed,
  /** Callback fired when when user leaves the body via dragging */
  onDragLeave?: (e: SyntheticDragEvent<HTMLDivElement>) => mixed,
  /** Callback fired when when user stops dragging on the body */
  onDrop?: (e: SyntheticDragEvent<HTMLDivElement>) => mixed,
  /** Contents of the body */
  children?: React.Node,
|};

const ModalBody = ({
  isFullBleed,
  bodyScroll,
  onDragOver,
  onDragLeave,
  onDrop,
  children,
}: Props) => {
  const className = classnames(styles.body, {
    [styles.fullBleed]: isFullBleed,
    [styles.hidden]: bodyScroll === 'hidden',
    [styles.visible]: bodyScroll === 'visible',
  });
  return (
    <div className={className} onDragOver={onDragOver} onDragLeave={onDragLeave} onDrop={onDrop}>
      {children}
    </div>
  );
};

export default ModalBody;
